import * as yup from 'yup';
import { PersonalDataEditModalFormData } from '@area/student/components/PersonalDataEditModal/types';

export const validationSchema = yup.object<PersonalDataEditModalFormData>({
  phoneNumber: yup
    .string()
    .trim()
    .matches(/^(\+[0-9]+)?$/, 'Неверный формат телефона'),
});
